"use strict";

exports.__esModule = true;
exports.AssigneeSection = AssigneeSection;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _DetailsComponent = require("../../Core/DetailsComponent");
var _Translator = require("../../Core/Translator");
var _AssignUser = require("./AssignUser");
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function AssigneeSection(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var assignee = props.assignee,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$muted = props.muted,
    muted = _props$muted === void 0 ? false : _props$muted,
    assigneeId = props.assigneeId,
    userId = props.userId,
    onAssignToUser = props.onAssignToUser;
  var _useState = (0, _react.useState)(false),
    isAssignUserOpen = _useState[0],
    setAssignUserOpen = _useState[1];
  function handleAssigneeChange() {
    var onChange = props.onChange;
    if (onChange) {
      onChange();
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
    muted: muted,
    heading: translate("TicketDetails.assignee", "Assignee"),
    content: /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }, assignee, userId !== assigneeId && /*#__PURE__*/_react["default"].createElement(_styles.StyledText, {
      disabled: disabled || muted,
      onClick: handleAssigneeChange
    }, translate("TicketDetails.assignee.button", "Assign To Me")), /*#__PURE__*/_react["default"].createElement(_styles.StyledText, {
      disabled: disabled || muted,
      onClick: function onClick() {
        return setAssignUserOpen(true);
      }
    }, translate("TicketDetails.assignee.assignToUser", "Assign To User"), /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: _icons.IconNames.CHEVRON_DOWN,
      style: {
        marginLeft: "1px"
      }
    })), /*#__PURE__*/_react["default"].createElement(_AssignUser.AssignUser, {
      isOpen: isAssignUserOpen,
      onClose: function onClose() {
        setAssignUserOpen(false);
      },
      onAssign: onAssignToUser,
      assigneeID: assigneeId
    }))
  });
}